/**
 * Слой потолков: подвесной потолок каждой комнаты (натяжной или гипсокартонный)
 * и видимость. По умолчанию потолки выключены — в 3D с любого ракурса они
 * закрывают квартиру сверху, а на плане перекрывают полы.
 */
import { create } from "zustand";
import { CeilingMaterial } from "@/shared/catalog";
import type { RoomCeiling } from "@/shared/plan";

interface CeilingLayerState {
	items: Record<string, RoomCeiling>;
	visible: boolean;

	/** Назначить комнате вид потолка; настройки, заданные пользователем, при смене вида сбрасываются */
	setRoomCeilingMaterial: (roomId: string, material: CeilingMaterial) => void;
	updateRoomCeiling: (roomId: string, patch: Partial<Pick<RoomCeiling, "drop" | "color">>) => void;
	removeRoomCeiling: (roomId: string) => void;

	setVisible: (visible: boolean) => void;
	toggleVisible: () => void;

	restoreCeilings: (items: Record<string, RoomCeiling>) => void;
}

export const useCeilingStore = create<CeilingLayerState>((set) => ({
	items: {},
	visible: false,

	setRoomCeilingMaterial: (roomId, material) =>
		set((s) => {
			if (s.items[roomId]?.material === material) return s;
			return { items: { ...s.items, [roomId]: { id: roomId, roomId, material } } };
		}),

	updateRoomCeiling: (roomId, patch) =>
		set((s) => {
			const ceiling = s.items[roomId];
			if (!ceiling) return s;
			return { items: { ...s.items, [roomId]: { ...ceiling, ...patch } } };
		}),

	removeRoomCeiling: (roomId) =>
		set((s) => {
			if (!s.items[roomId]) return s;
			const items = { ...s.items };
			delete items[roomId];
			return { items };
		}),

	setVisible: (visible) => set({ visible }),
	toggleVisible: () => set((s) => ({ visible: !s.visible })),

	restoreCeilings: (items) => set({ items }),
}));
